import Vue from 'vue'
export default {
    SET_REQUEST_STATE(state, { requestName, status }) {
        Vue.set(state.requests, requestName, status);
    }
}